import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmCalendarIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmCalendarIcon = ({ className, ...props }: EmCalendarIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.17065 7.86844V18.9956C1.17065 19.5319 1.66909 19.8911 2.2569 20.3036C2.92722 20.7745 3.7144 21.2059 4.00487 21.2059L20.0838 21.3125C20.4963 21.3125 20.8297 20.8072 20.8297 20.3947V7.86844H1.17065Z"
      fill="#BDBDBD"
    />
    <path
      d="M20.8296 20.3947L19.4065 18.932V7.54874L20.8296 7.51608V20.3947Z"
      fill="url(#paint0_linear_286_33613)"
      opacity="0.29"
    />
    <path
      d="M20.8297 8.82063L19.7193 8.12453L17.9817 0.6875C17.9817 0.6875 18.0848 0.6875 18.9167 0.6875C20.5753 0.6875 20.8297 1.64484 20.8297 1.97141V8.82063Z"
      fill="#C62828"
    />
    <path
      d="M1.6759 7.86844V18.6416C1.6759 19.1056 2.05231 19.4803 2.51465 19.4803H18.817C19.2811 19.4803 19.7142 19.1348 19.7142 18.6708V17.7702V7.86844H1.6759Z"
      fill="#FAFAFA"
    />
    <path
      d="M19.7193 8.12453H1.17053V1.67578C1.17053 1.12922 1.61225 0.6875 2.15881 0.6875H18.7602C19.3085 0.6875 19.7519 1.13266 19.7485 1.68094L19.7193 8.12453Z"
      fill="#F44336"
    />
    <path
      d="M7.21036 2.6572H7.91848V5.03595C7.91848 5.25423 7.87036 5.44845 7.77411 5.61516C7.67786 5.78188 7.54036 5.91251 7.36504 6.0036C7.18801 6.0947 6.99036 6.1411 6.76864 6.1411C6.40598 6.1411 6.12239 6.04829 5.91958 5.86438C5.71676 5.68048 5.61536 5.41751 5.61536 5.08063H6.32864C6.32864 5.24907 6.36473 5.37282 6.4352 5.4536C6.50567 5.53438 6.61739 5.57392 6.77036 5.57392C6.90614 5.57392 7.0127 5.52751 7.09348 5.4347C7.17426 5.34188 7.21379 5.20954 7.21379 5.03766V2.6572H7.21036Z"
      fill="white"
    />
    <path
      d="M10.0084 5.83343C9.83997 6.03796 9.60793 6.13937 9.31059 6.13937C9.03731 6.13937 8.82762 6.06031 8.68497 5.9039C8.54059 5.74749 8.46668 5.51546 8.46497 5.21296V3.54062H9.14731V5.19234C9.14731 5.45874 9.26762 5.59109 9.50997 5.59109C9.742 5.59109 9.90012 5.51031 9.98606 5.35046V3.54062H10.6701V6.09296H10.029L10.0084 5.83343Z"
      fill="white"
    />
    <path
      d="M11.9026 6.09297H11.2185V2.46985H11.9026V6.09297Z"
      fill="white"
    />
    <path
      d="M13.4168 5.12703L13.8894 3.53891H14.6216L13.5955 6.48828L13.5388 6.62235C13.3858 6.95578 13.1349 7.1225 12.7843 7.1225C12.6846 7.1225 12.5849 7.10703 12.4818 7.07782V6.56047L12.5849 6.56219C12.7138 6.56219 12.81 6.54328 12.8736 6.50375C12.9372 6.46422 12.9871 6.39891 13.0232 6.30782L13.104 6.09813L12.2102 3.53891H12.9441L13.4168 5.12703Z"
      fill="white"
    />
    <path
      d="M8.86543 17.5845H7.39074V11.9041L5.63074 12.4489V11.2509L8.70558 10.1492H8.86371V17.5845H8.86543Z"
      fill="currentColor"
    />
    <path
      d="M15.8041 10.9828L12.9338 17.5845H11.3783L14.2538 11.3489H10.5619V10.1613H15.8041V10.9828Z"
      fill="currentColor"
    />
    <path
      d="M19.7142 8.97876L1.6759 8.99767V8.12454H19.7142V8.97876Z"
      fill="#616161"
      opacity="0.29"
    />
    <path
      d="M3.91904 4.26939C4.593 4.26939 5.13936 3.72304 5.13936 3.04908C5.13936 2.37512 4.593 1.82877 3.91904 1.82877C3.24508 1.82877 2.69873 2.37512 2.69873 3.04908C2.69873 3.72304 3.24508 4.26939 3.91904 4.26939Z"
      fill="#606060"
    />
    <path
      d="M3.51328 3.86546C4.18724 3.86546 4.73359 3.31911 4.73359 2.64515C4.73359 1.97119 4.18724 1.42484 3.51328 1.42484C2.83932 1.42484 2.29297 1.97119 2.29297 2.64515C2.29297 3.31911 2.83932 3.86546 3.51328 3.86546Z"
      fill="#94D1E0"
    />
    <path
      d="M3.61818 2.13983C3.59068 2.28593 3.49787 2.40968 3.39131 2.51452C3.26412 2.63827 3.11459 2.7414 2.94615 2.79812C2.84646 2.83249 2.73131 2.84624 2.64365 2.7878C2.40131 2.62452 2.59552 2.01093 2.77943 1.84765C3.05959 1.60015 3.71443 1.64655 3.61818 2.13983Z"
      fill="#C9EFF2"
    />
    <path
      d="M17.4114 4.26939C18.0853 4.26939 18.6317 3.72304 18.6317 3.04908C18.6317 2.37512 18.0853 1.82877 17.4114 1.82877C16.7374 1.82877 16.191 2.37512 16.191 3.04908C16.191 3.72304 16.7374 4.26939 17.4114 4.26939Z"
      fill="#606060"
    />
    <path
      d="M17.0073 3.86546C17.6813 3.86546 18.2276 3.31911 18.2276 2.64515C18.2276 1.97119 17.6813 1.42484 17.0073 1.42484C16.3333 1.42484 15.787 1.97119 15.787 2.64515C15.787 3.31911 16.3333 3.86546 17.0073 3.86546Z"
      fill="#94D1E0"
    />
    <path
      d="M17.1123 2.13983C17.0848 2.28593 16.992 2.40968 16.8854 2.51452C16.7583 2.63827 16.6087 2.7414 16.4403 2.79812C16.3406 2.83249 16.2254 2.84624 16.1378 2.7878C15.8954 2.62452 16.0897 2.01093 16.2736 1.84765C16.5537 1.60015 17.2069 1.64655 17.1123 2.13983Z"
      fill="#C9EFF2"
    />
    <path
      d="M17.8253 20.4084C17.2787 20.4755 16.7321 20.5047 16.1856 20.5528C15.639 20.5872 15.0925 20.6181 14.5459 20.6388C13.9993 20.6663 13.4528 20.6714 12.9062 20.6886L11.2665 20.7041L9.62683 20.6869C9.08026 20.6714 8.5337 20.6645 7.98714 20.637C7.44058 20.6164 6.89401 20.5855 6.34745 20.5511C5.80089 20.503 5.25433 20.4738 4.70776 20.4067V20.3724L11.2648 20.3552L17.8218 20.3724V20.4084H17.8253Z"
      fill="#757575"
    />
    <path
      d="M14.5236 19.4803H18.8754C19.3395 19.4803 19.7142 19.1039 19.7142 18.6416V15.4739C19.7142 15.4739 18.7689 16.787 17.3372 17.8664C15.9054 18.9458 14.5236 19.4803 14.5236 19.4803Z"
      fill="#757575"
    />
    <path
      d="M18.42 17.9283C19.7469 16.3659 19.7142 15.4756 19.7142 15.4756C19.7142 15.4756 19.3309 16.0153 18.1261 16.1373C17.7015 16.1803 17.0931 16.017 16.6445 15.8675C16.3747 15.7781 16.0945 15.9706 16.0859 16.2525C16.0739 16.6151 16.0137 17.1239 15.8195 17.7289C15.4964 18.7395 14.5219 19.482 14.5219 19.482C14.5219 19.482 16.9367 19.6728 18.42 17.9283Z"
      fill="#BDBDBD"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_286_33613"
        x1="20.118"
        x2="20.118"
        y1="12.8398"
        y2="19.7026"
      >
        <stop
          offset="0.3374"
          stopColor="#616161"
        />
        <stop
          offset="1"
          stopColor="#616161"
          stopOpacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
);

export default EmCalendarIcon;
